import { TenantPerformableFormProps } from '~/tenants/common/form';
import { MlmOrderContext } from '../../model/MlmOrder';
import { TenantPackageAddOnCheckboxName } from '~/tenants/common/package';
import { MLM_WALKTHROUGH_AGENT } from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughJob';

export default function MlmWalkthroughForm({ persona }: TenantPerformableFormProps<MlmOrderContext>) {
  return (
    <TenantPackageAddOnCheckboxName
      name="agent"
      image={null}
      persona={persona}
      cost={MLM_WALKTHROUGH_AGENT}
      title="Agent on Camera"
      description="Addition to walkthrough video where agent is filmed describing property while on-site. Subject to additional scheduling requirements, and scheduling at the same time as photography may not be possible. Agent must be prepared with a script and ready for filming at the scheduled time."
    />
  );
}
